import { render, staticRenderFns } from "./branch-modal.vue?vue&type=template&id=005887e8&"
import script from "./branch-modal.vue?vue&type=script&lang=js&"
export * from "./branch-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports